import { peopleContactCardQuickAction } from './PeopleSearchSuggestion.locstring.json';
import loc from 'owa-localize';
import SearchSuggestion from './SearchSuggestion';
import SearchScenarioId from '../../store/schema/SearchScenarioId';
import highlightDisplayText from '../../utils/highlightDisplayText';
import PeopleSuggestionPersonaCard from '../PeopleSuggestionPersonaCard';
import { observer } from 'mobx-react';
import { IPersonaProps, PersonaSize } from 'office-ui-fabric-react/lib/Persona';
import { isFeatureEnabled } from 'owa-feature-flags';
import PersonaControl from 'owa-persona/lib/components/PersonaControl';
import { PeopleSuggestion } from 'owa-search-service';

import * as React from 'react';
import {
    TooltipHost,
    DirectionalHint,
    TooltipOverflowMode,
} from 'office-ui-fabric-react/lib/Tooltip';

const styles = require('./PeopleSearchSuggestion.scss');

export interface PeopleSuggestionProps {
    index: number;
    scenarioId: SearchScenarioId;
    suggestion: PeopleSuggestion;
    suggestionSetTraceId: string;
}

@observer
export class PeopleSearchSuggestion extends React.Component<PeopleSuggestionProps, {}> {
    render() {
        const { index, scenarioId, suggestion, suggestionSetTraceId } = this.props;

        /**
         * This calculation is here (instead of inside of onRenderPrimaryText
         * where it is used) so the render function takes a dependency on
         * suggesiton.HighlightedDisplayName and re-renders properly. See VSTS
         * #33079 for more details.
         */
        const hitHighlightedDisplayText = highlightDisplayText(suggestion.HighlightedDisplayName)
            .filter(e => e.text.length > 0)
            .map((e, i) => (
                <div
                    key={i}
                    className={
                        e.isHighlighted
                            ? styles.personaKeywordMatchSuggestion
                            : styles.personaKeywordNonMatchSuggestion
                    }>
                    {e.text}
                </div>
            ));

        return (
            <SearchSuggestion
                ariaLabel={suggestion.DisplayName}
                content={
                    <PersonaControl
                        className={styles.personaControl}
                        emailAddress={suggestion.EmailAddresses[0]}
                        name={suggestion.DisplayName}
                        secondaryText={suggestion.EmailAddresses[0]}
                        showSecondaryText={true}
                        showPersonaDetails={true}
                        showPresence={false}
                        size={PersonaSize.size28}
                        onRenderPrimaryText={this.onRenderPrimaryText(hitHighlightedDisplayText)}
                        mailboxType={suggestion.MailboxType}
                    />
                }
                quickActions={this.getQuickActions()}
                suggestion={suggestion}
                scenarioId={scenarioId}
                suggestionSetTraceId={suggestionSetTraceId}
                index={index}
            />
        );
    }

    private onRenderPrimaryText(hitHighlightedDisplayText: JSX.Element[]) {
        return (props: IPersonaProps): JSX.Element => {
            return (
                <TooltipHost
                    content={props.primaryText}
                    directionalHint={DirectionalHint.topLeftEdge}
                    overflowMode={TooltipOverflowMode.Parent}>
                    {hitHighlightedDisplayText}
                </TooltipHost>
            );
        };
    }

    private getQuickActions = () => {
        if (!isFeatureEnabled('sea-personaCardInSuggestions')) {
            return [];
        }

        const { suggestion, scenarioId, index, suggestionSetTraceId } = this.props;
        const quickActions = [];

        quickActions.push(
            <TooltipHost
                content={loc(peopleContactCardQuickAction)}
                directionalHint={DirectionalHint.topCenter}
                id="personaCardButton">
                <PeopleSuggestionPersonaCard
                    name={suggestion.DisplayName}
                    emailAddress={suggestion.EmailAddresses[0]}
                    disableHover={true}
                    locationToOpen={'ExpandedView'}
                    aria-describedby="personaCardButton"
                    scenarioId={scenarioId}
                    clientScenario={'PersonaSuggestionLPC'}
                    suggestionIndex={index}
                    suggestion={suggestion}
                    suggestionSetTraceId={suggestionSetTraceId}
                />
            </TooltipHost>
        );

        return quickActions;
    };
}
